module.exports = __webpack_public_path__ + "img/close-blue.532996c3.svg";